var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3176_44036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56767 11.0964V7.67303C7.5687 6.91046 7.87222 6.17945 8.41162 5.64041C8.95102 5.10138 9.68224 4.79835 10.4448 4.79784H16.2768V4.08827C16.2763 3.25437 15.9451 2.45472 15.3558 1.8647C14.7665 1.27468 13.9673 0.942462 13.1334 0.940918H3.58827C2.7537 0.941433 1.95346 1.27319 1.36333 1.86333C0.773194 2.45346 0.441433 3.2537 0.440918 4.08827V8.53229C0.441432 9.36704 0.773131 10.1675 1.36321 10.7579C1.95328 11.3484 2.75352 11.6806 3.58827 11.6816H5.3165L4.89465 13.9736C4.88805 14.0081 4.89213 14.0438 4.90634 14.076C4.92056 14.1081 4.94423 14.1352 4.97421 14.1536C5.00418 14.1719 5.03905 14.1807 5.07415 14.1788C5.10925 14.1769 5.14293 14.1643 5.1707 14.1427L7.77179 12.154C7.63742 11.8176 7.56816 11.4587 7.56767 11.0964Z",
    fill: "#050033",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7952 5.28369H10.4448C9.81117 5.28421 9.20357 5.53603 8.75531 5.98392C8.30706 6.43181 8.05474 7.03921 8.05371 7.67288V11.0963C8.05474 11.73 8.30706 12.3374 8.75531 12.7853C9.20357 13.2331 9.81117 13.485 10.4448 13.4855H14.049L16.5763 15.4159C16.5975 15.4329 16.6235 15.4429 16.6506 15.4445C16.6778 15.4462 16.7048 15.4394 16.728 15.4252C16.7511 15.411 16.7694 15.3899 16.7801 15.3649C16.7909 15.34 16.7937 15.3123 16.7882 15.2856L16.4518 13.4855H17.7893C18.4228 13.485 19.0302 13.2331 19.4782 12.7851C19.9261 12.3372 20.178 11.7298 20.1785 11.0963V7.67288C20.178 7.0404 19.9269 6.43388 19.4802 5.98609C19.0335 5.53831 18.4276 5.28575 17.7952 5.28369Z",
    fill: "#050033",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3176_44036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.625,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.216218b2aac1c55944a946be3123813e.svg";
export { ForwardRef as ReactComponent };